module.exports = __webpack_public_path__ + "img/person-3.461cb5bf.jpg";